import AbstractDevice from '../all/AbstractDevice';
import ArrisId from "./Id";
import ArrisPlayer from "./Player";
import ArrisPlayerUtil from "./PlayerUtil";
import ArrisConfig from "./config";
import ArrisKeys from "./Keys";
import ArrisNetworkStatus from "./NetworkStatus";
import ArrisSystem from "./System";

class ArrisDevice extends AbstractDevice {
  constructor () {
    super(
      "arris",
      new ArrisId(),
      new ArrisPlayer(),
      new ArrisPlayerUtil(),
      ArrisConfig,
      new ArrisKeys(),
      new ArrisNetworkStatus(),
      new ArrisSystem()
    );
  }
  disableArrisKeys() {
    let callbackFunction = text => {
      console.log('[Arris] Activating Keys in ClaroVideo');
      console.log('[Arris] ' + text);
    };
    this._sendKeyFilter(
      ['VK_GUIDE', 'VK_CHANNEL_UP', 'VK_CHANNEL_DOWN', 'VK_MENU'],
      false,
      callbackFunction
    );
  }

  _sendKeyFilter(aKeys, passKeys, cb) {
    var dest = passKeys ? 'local' : 'remote';
    var urlStr = 'http://session/client/keyfilter?process=' + dest;
    for (let i = 0; i < aKeys.length; i++) {
      urlStr += '&keycode=' + aKeys[i];
    }
    var xhr = new XMLHttpRequest();
    xhr.url = urlStr;
    xhr.onreadystatechange = function() {
      if (this.readyState == 4) {
        cb('Waiting');
      }
    };
    xhr.onerror = function(e) {
      console.error('[Arris] Error calling the URL: ' + urlStr);
    };
    xhr.onload = function(e) {
      cb('Success');
    };
    xhr.open('POST', xhr.url, true);
    xhr.send('');
  }
}

export default ArrisDevice;



// WEBPACK FOOTER //
// ./src/devices/arris/Device.js